// extracted by mini-css-extract-plugin
export default {"root":"root-GeB3nX","name":"name-oAXWNb","language":"language-rh9Vcb","profile":"profile-Q_Xi4z","email":"email-yN_li7","icon":"icon-Etm8jW"};